import axios from 'axios'
import { host } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'

const PLUGINS_NAME = 'admin-game-periods'

// keno
export const getKenoPeriods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-keno`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

// max3d
export const getMax3dPeriods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-max3d`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// max3dpro
export const getMax3dProPeriods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-max3dpro`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// mega
export const getMegaPeriods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-mega`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

// power
export const getPowerPeriods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-power`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getLotto535Periods = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-lotto535`, {
        ...query,
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getCurrentPeriodTicket = async (token) => {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/get-current-period-ticket`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const getCurrentGamePeriods = async (token) => {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/get-current-game-period`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        const rows = response.data || []
        if (Array.isArray(rows)) {
            return rows
        }
    }

    return []
}
